import React, { SVGProps } from 'react';
import cn from 'classnames';
import { bem } from '@react-md/utils';
const block = bem('rmd-icon');
const SvgSlidersHorizontal = (props: SVGProps<SVGSVGElement>) => {
    props = Object.assign(
        {
            'aria-hidden': true,
        },
        props,
        {
            className: cn(block(), props.className),
        },
    );
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            fill="none"
            viewBox="0 0 16 16"
            role="img"
            {...props}
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M13.333 4.667h-6M9.333 11.333h-6M11.333 13.333a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM4.667 6.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            />
        </svg>
    );
};
export default SvgSlidersHorizontal;
